module.exports = __webpack_public_path__ + "img/login-image.3521981f.png";